/**
 * LegacyFinancialSections.jsx
 *
 * Complete financial sections block for supplier info sheets saved before
 * schemaVersion 2. Uses the original multi-card layout with all sections.
 *
 * DO NOT modify the field names used here - they must match what is stored
 * in the DB for old finalized records (v1 field names).
 */
import { Col, Row } from "react-bootstrap";
import ContractSecuritySection from "./ContractSecuritySection";
import ContractSummarySection from "./ContractSummarySection";
import CorrectionsSection from "./CorrectionsSection";
import DeductionsSection from "./DeductionsSection";
import PerformanceOverviewSection from "./PerformanceOverviewSection";
import PerformancePeriodSection from "./PerformancePeriodSection";
import SecurityCalculationSection from "./SecurityCalculationSection";
import TotalSummarySection from "./TotalSummarySection";
import { SectionNumberingProvider } from "../hooks/useSectionNumbering";

/**
 * Drop-in replacement for the full financial block in index.jsx when
 * schemaVersion is absent (legacy / v1 stored record).
 */
const LegacyFinancialSections = () => (
    <SectionNumberingProvider>
        <Row className="justify-content-center">
            <Col md={5}>
                <ContractSummarySection />
            </Col>
            <Col md={5}>
                <PerformancePeriodSection />
            </Col>
        </Row>

        <Row className="justify-content-center">
            <Col md={5}>
                <PerformanceOverviewSection />
            </Col>
            <Col md={5}>
                <ContractSecuritySection />
            </Col>
        </Row>

        <Row className="justify-content-center">
            <Col md={5}>
                <DeductionsSection />
            </Col>
            <Col md={5}>
                <SecurityCalculationSection />
            </Col>
        </Row>

        <Row className="justify-content-center">
            <Col md={5}>
                <CorrectionsSection />
            </Col>
            <Col md={5}></Col>
        </Row>

        <Row className="justify-content-center">
            <Col md={5}>
                <TotalSummarySection />
            </Col>
            <Col md={5}></Col>
        </Row>
    </SectionNumberingProvider>
);

export default LegacyFinancialSections;
